
export default{
    header:{
        logo: '开普勒开发者平台',
        discover: "发现",
        documents: "文档",
        downloads: "下载",
        resourceDownloads: "资源下载",
        appDownload: "APP下载",
        simulationDownloads: "仿真下载",
        about: "关于",
        userEntrance: "注册/登录",
        messages: "消息",
        console: "控制台",
        personalCenter : "个人中心",
        logout : "退出登录",
    },
    footer:{
        aboutKepler : "关于开普勒",
        ourStory : "公司介绍",
        contactUs : "联系我们",
        followorContactUs : "关注或联系我们",
        email: "邮箱",
        copyright1: `Copyright © gotokepler.com, All Rights Reserved. 上海开普勒机器人有限公司版权所有`,
        copyright2: " 沪ICP备 2023025649号-1"
    },
    discover:{
        coreTechnologies: "核心技术",
        learnMore: "了解更多",
        releasetime: "发布时间",
        robotCapabilities: "机器人能力",
        tryItNow: "立即体验",
    },
    document:{
        enterkeywords: "输入关键词",
        searchResults: "搜索结果",
        total: '共',
        results: "条结果",
        noMore: "暂无更多内容",
        documentDirectory: "文档目录",
        pageGuide: "本页导读",
        updateTime: "更新时间",
        noContent: "暂无内容",
        nodata: "暂无数据",
    },
    download:{
        projectDirectory: "项目目录",
        resourceDownloads: "资源下载",
        download: "下载",
        updateLog: "更新日志",
        noProjectTips: "暂无项目, 请联系平台管理员进行项目定制",
        appDownloadTitle: "KEPLER开普勒控制平台",
        appDownloadDesc: "为开普勒通用人形机器人打造的高仿真训练平台",
        qrDownload: "扫描二维码下载",
        downloadNow: "立即下载",
        kepler: "KEPLER开普勒",
        previous: '上一篇',
        next: '下一篇',
        none: '暂无',
        loading: '正在加载中...',
        loadMore: '加载更多',
    },
    about: {
        programTitle_1: "内置智能程序",
        programContent_1: "内置多个智能程序，包括视觉识别、导航和行走等功能，这些功能的拥有者可以直接使用，无需额外开发，通电即用。",
        programTitle_2: "详细文档参考",
        programContent_2: "提供详细的文档说明，包括接口说明、功能实现原理和使用示例等，使用户能够快速上手和开发自己的应用程序。",
        programTitle_3: "自研操作系统",
        programContent_3: "让机器人的拥有者成为开发者，他们可以通过开放平台中的工具和资源，深入了解机器人的内部工作原理，定制化开发符合自己需求的功能和应用。",
        programTitle_4: "开放自由程度",
        programContent_4: "从系统代码开源到接口开发，使机器人的拥有者可以轻松地与机器人进行交互和开发，实现各种个性化的功能和应用。",
        useTitle: '开发者平台如何使用？',
        useContent: 'Kepler OS 是首家人形机器人对外开放的操作系统，采用模块化设计，将机器人系统划分为动作执行、视觉识别、语音交互等多个模块,通过开放接口实现高度集成。开发者可以根据需要开发各种应用模块，也可以通过可视化编程工具快速构建工作流和场景。系统提供丰富的示例项目和开发文档，帮助开发者快速上手。它还支持多机协同，开发者可以通过网络轻松连接和协调多个机器人。此外，该系统提供强大的在线开发和调试功能。用户可以通过网络在线编写程序和参数，实时查看机器人运行状态，进行远程控制和问题定位，大幅提高研发效率。未来还将支持Over-The-Air更新，实现机器人软件的远程升级和维护。总之，基于人性化和开放协作理念,该操作系统将极大促进机器人软件开发,助力机器人应用领域的发展。',
        senceTitile: '开发者平台的广泛运用场景？',
        senceContent: '提供产业线/科研机构建立以智能化为核心的定制化方案',
        senceDesc: '通过开放者平台,开发人员可以自主对机器人进行定制化开发,实现各种人机自动化应用,而无需关注硬件细节,大幅提高研发效率。',
        senceTitle_1: "统一智能中心",
        senceContent_1: "每个人形机器人都经过充分测试，为进一步开发提供可靠的平台，实现智能解决方案的快速实施。",
        senceTitle_2: "1v1定制化个性化方案",
        senceContent_2: "合作伙伴集成商深入了解工厂生产流程，根据需求定制1v1实施工作流程方案，让机器人更好地适应工厂的特殊需求。",
        senceTitle_3: "快速落地构建场景/研究应用",
        senceContent_3: "为企业构建个性化应用，为企业提供技术支持和服务，保证系统长期稳定运行。",
        bottomBanTitle: "全球合作伙伴",
        bottomBanContent: "携手共创，诚邀全球合作伙伴",
        bottomBanDesc: "人形机器人的开发与发展，应汇聚全球智慧。开普勒向全球的开发者们发出邀请，一起开创人形机器人应用，实现科研与产业线的智能开发，共同开发出改变世界的人形机器人应用！",
    },
    login:{
        accountLogin: "账号登录",
        pleaseEnterEmail: "请输入邮箱",
        incorrectEmailFormat: "邮箱格式不正确",
        pleaseEnterPassword: "请输入登录密码",
        pleaseWriterPassword: "请填写登录密码",
        pswRule: "密码长度为6-20位",
        accountIncorrect: "账号或密码不正确",
        readAndAgreement: "已阅读并同意",
        and: "和",
        userAgreement: "《用户协议》",
        privacyPolicy: "《隐私政策》",
        login: "登录",
        noAccount: "还没有账号？",
        registerNow: "立即注册",
        forgetPsw: "忘记密码",
        loginSuccess: '恭喜您登录成功',
        confirmLogout: '是否确认退出登录？',
        confirm: '确认',
        cancel: '取消',
        resetPassword: '重置密码',
        returnToLogin: '返回账号登录',
        verifyAccount: '验证账号',
        setNewPsw: '设置新密码',
        resetPswSuccess: '密码重置成功',
        nextStep: '下一步',
        setPassword: '设置密码',
        confirmPsw: '确认密码',
        accountPlaceholder: "手机号/邮箱",
        writeAccount: "请填写手机号或邮箱",
        enterAccount: "请输入手机号或邮箱",
        pleaseAgreeWebTerms: "请勾选同意⽤户协议和隐私政策",
        // verifyAccount: '验证账号',


    },
    register:{
        accountRegistration: "账号注册",
        // region: "国家/地区",
        verificationCode: "请输入验证码",
        pleaseEnterVerificationCode: "请输入验证码",
        pleaseEnterEmailAddress: "请输入邮箱地址",
        getVerificationCode: "获取验证码",
        resendCodeTips: "s重新发送",
        codeSend: "验证码已发送，请注意查收",
        rewrite: '验证码错误，请重新填写',
        setPswRule: '请设置6-20位登录密码',
        pleaseEnterPsw: '请输入密码',
        pleaseConfirmPsw: '请确认密码',
        register: "注册",
        existingAccount: '已有账号？',
        loginNow: "立即登录",
        registerSuccess: "恭喜您注册成功",
        keepAccountSafe: '请妥善保管你的账户信息',
        enterHomepage: "进入首页",
        pswnomatch: "密码不⼀致，请重新填写",

    },
    personalCenter:{
        // 控制台
        myProjects: "我的项目",
        pleaseCertification: "暂无项目，请先完成开发者认证",
        certifiedDeveloper: "注册认证开发者",
        developerCertification: "开发者认证",
        submit: "提交",
        submitCertificationInfo: "提交认证资料",
        pendingReview: "等待资料审核",
        certifiedSuccess: "实名认证成功",
        yourName: "您的姓名",
        pleaseEnterRelName: "请填写身份证上的真实姓名",
        pleaseEnterYourName: "请填写姓名",
        companyName: "企业名称",
        pleaseEnterRelCompanyName: "请填写营业执照上的企业名称",
        pleaseEnterCompanyName: "请填写企业名称",
        phoneNumber: "手机号码",
        writeTelOrEmail: "请填写联系人的手机号或邮箱",
        contactInfo: "联系方式",
        writeContactInfo: "请填写联系方式",
        snCode: "机器SN码",
        writeSnCode: "请填写机器SN码",
        modifyProjectName: "修改项目名称",
        newProjectName: "请输入新的项目名称",
        cannotEmpty: "项目名称不能为空",
        operationSuccessful: "操作成功",
        resourceDownloads: "资源下载",
        developmentDocuments: "开发文档",
        accountInformation: "账号信息",
        accountName: "账号名称",
        accountCertification: "账号认证",
        goCertify: "去认证",
        certified: "已认证",
        details: "详情",
        individualDeveloper: '个人开发者',
        enterpriseDeveloper: '企业级开发者',
        underCertification: '认证中',

        // 系统设置
        systemNotices: "系统公告",
        more: "更多",
        systemSettings: "系统设置",
        accountProfile: "账号资料",
        basicInfo: "基本信息",
        account: "账号",
        contactEmail: "联系邮箱",
        notBoundYet: "暂未绑定",
        gotoBind: "去绑定",
        bindEmail: "绑定邮箱",
        writeBindEmail: "请输入要绑定的邮箱",
        writeCodeYzm: "请输入邮箱验证码",
        getVerificationCode: "获取邮箱验证码",
        cancel: "取消",
        confirm: "确定",
        accountPassword: "账号密码",
        gotoChange: "去修改",
        accountIdentity: "账号身份",
        notObtainedYet : "暂未获得",
        gotoCertify: "去认证",
        certified: "已认证",

        // 修改密码
        modifyPsw: "修改密码",
        originalPsw: "原密码",
        writeOriginalPsw: "请输入原登录密码",
        newPsw: "新密码",
        confirmNewPsw: "确认新密码",
        writeNewPsw: "请输入新的登录密码",
        rewriteLoginPsw: "再次输入登录密码",
        writeOriginalPswWarn: '请填写原密码',
        writeNewPswWarn: '请填写新的密码',
        rewriteLoginPswWarn: '请输入密码',

        // 系统通知
        systemNotice: "系统通知",
        allAsRead: "全部标识为已读",
        noticeTitle: "通知标题",
        certificationApproved: "认证审核通过",
        certificationNotApproved: "认证审核未通过",
        status: "状态",
        read: "已读",
        unread: "未读",
        type: "类型",
        certificationReview: "认证审核",
        releaseTime: "发布时间",
        totalPage: "共",
        currentPage: "当前第",
        toPage: "前往",
        page: "页",
        noPermission: '暂无查看权限',
        noArticleTips: '暂无文章内容，看看其他内容吧',
        noTips: '暂无公告',
        noNetwork: '网络跑到外太空了，先休息下吧',
    },
    verificationTips:{
        telEmptyTips: '手机号码不能为空',
        telErrorTips: '手机号码格式不正确',
        snCodeEmptyTips: '机器SN码不能为空',
        snCodeErrorTips: '机器SN码格式不正确',
        nameEmptyTips: '姓名不能为空',
        nameErrorTips: '姓名长度不能超过20',
        coNameEmptyTips: '企业名称不能为空',
        coNameErrorTips: '企业名称长度长度不能超过20',
        yzmEmptyTips: '验证码不能为空',
        yzmErrorTips: '验证码为六位数字',
        emailEmptyTips: '邮箱不能为空',
        emailErrorTips: '邮箱格式不正确',
        accountEmptyTips: '请输入手机号或邮箱',
        accountErrorTips: '请输入正确的手机号或邮箱',
        pswEmptyTips: '密码不能为空',
        pswErrorTips: '密码长度为6-20位',
        serviceErrorTips: '操作失败，请稍后再试',
    },
    newDownload:{
        softwareLabel: "软件",
        studioTitle: "Kepler Studio",
        studioDesc: "集成图形化积木编程、动作编辑、逻辑运算、仿真预览与一键部署，一站式机器人可视化开发平台。",
        systemTitle: "外骨骼遥操系统",
        systemDesc: "面向机器人外骨骼设备的远程遥操管控系统，实现实时运动控制、状态监测与作业调度。",
        simulationTitle: "仿真APP",
        simulationDesc: "依托数字孪生技术，对机器人运动轨迹、作业流程进行全场景仿真与测试验证。",
        viewAppTitle: "展示APP",
        viewAppDesc: "一款智能机器人展示控制 APP，支持设备行走操控、预设动作调用与趣味表情一键切换。",
        btnText: "立即体验",
        dialogTitle: "提示",
        dialogContent: "权限不足，请联系工作人员",
        dialogConfirmText: "确定",
    }

}